import { Component, AfterViewInit, OnInit, OnDestroy, EventEmitter, Input, Output } from '@angular/core';

import { TinymceService } from '../../../services/common/tinymce.service';

declare var tinymce: any;
declare var jQuery: any;

@Component({
  selector: 'app-tinymce-css',
  templateUrl: './tinymce-css.component.html',
  styleUrls: ['./tinymce-css.component.css'],
})
export class TinymceCssComponent implements OnInit, AfterViewInit {
  @Input() css_files: any;
  @Input() initialContent: String;
  @Input() elementId: String;
  @Input() stylesheet_formats: any;
  @Output() onEditorKeyup: EventEmitter<string> = new EventEmitter<string>();
  @Output() wordCount: EventEmitter<number> = new EventEmitter<number>();

  editor: any;

  constructor(private tinymceService: TinymceService) {}

  // Component lifecycle methods
  ngOnInit() {
    if (!this.elementId) this.elementId = `tinymce-${this.tinymceService.randomString(10)}`;
  }

  ngAfterViewInit() {
    if (this.css_files && this.stylesheet_formats) this.initializeTinymce(this.css_files, this.stylesheet_formats);
  }

  ngOnDestroy() {
    if (typeof tinymce !== 'undefined' && this.editor) tinymce.remove(this.editor);
  }

  // Component methods
  getWordCount(): number {
    return this.editor.plugins.wordcount.getCount();
  }

  initializeTinymce(css_files: any, stylesheet_formats: any) {
    if (typeof tinymce === 'undefined') return;
    if (this.editor) return;
    var fontsize_formats = '5pt';
    for (var i = 6; i < 100; i = i + 1) fontsize_formats += ' ' + i + 'pt';
    var font_size = 12;
    tinymce.init({
      selector: '#' + this.elementId,
      branding: false,
      menubar: true,
      theme: 'silver',
      body_class: 'tinymce_float_toolbar',
      fontsize_formats: fontsize_formats,
      //inline:                           true,
      height: 500,
      width: '180mm',
      resize: 'both',
      plugins: 'advlist autolink lists link image charmap print preview hr anchor pagebreak,searchreplace wordcount visualblocks visualchars code fullscreen,insertdatetime media nonbreaking save table directionality,emoticons template paste textpattern pagebreak',
      toolbar1: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist olnumberstarter outdent indent tabspacer pagebreaker | link image',
      browser_spellcheck: true,
      contextmenu: false,
      toolbar2: 'print preview media | forecolor backcolor emoticons | fontsizeselect doublespace | insertlogo',
      image_advtab: true,
      content_css: css_files,
      content_style: '.r_tag_pagebreak{height:1px !important;background-color:red;width:100%;padding: 0 5mm 0 5mm;}body{font-size: ' + (font_size || 12) + 'pt;}',
      importcss_merge_classes: true,
      nonbreaking_force_tab: true,
      relative_urls: false,
      style_formats_merge: true,
      style_formats: stylesheet_formats,
      theme_advanced_toolbar_location: 'external',
      theme_advanced_toolbar_align: 'left',
      theme_advanced_statusbar_location: 'top',
      extended_valid_elements: '+@[page-selection],span[*]',
      forced_root_block: false,
      force_p_newlines: false,
      min_height: 300,
      // make toolbar dragable
      handle_event_callback: function (e: any) {
        if (e.type == 'click') {
          jQuery('.mceExternalToolbar').draggable();
        }
        return true;
      },
      advlist_number_styles: 'decimal,lower-alpha,lower-greek,lower-roman,upper-alpha,upper-roman',
      setup: (editor: any) => {
        this.editor = editor;
        editor.on('init', () => this.enableNativeSpellcheck(editor));
        editor.on('keyup', () => {
          const content = editor.getContent();
          this.onEditorKeyup.emit(content);
          this.wordCount.emit(editor.plugins.wordcount.getCount());
        });
        this.tinymceService.setFocusAndBlur(editor);
        this.tinymceService.add_tabspacer_tinymce(editor);
        this.tinymceService.add_start_number_ol_tinymce(editor);
        this.tinymceService.font_size_change_tinymce(editor);
        this.tinymceService.add_double_space_tinymce(editor);
        this.tinymceService.insert_logo_tinymce_button(editor);
        this.tinymceService.watermark_tinymce(editor);
        editor.on('SetContent', (e: any) => {
          if (e.content && e.content.indexOf('class="mce-pagebreak"') > -1) {
            console.log('Page break detected', e, editor);
            e.content = e.content.replace('<p>', '<div>').replace('</p>', '</div>');
          }
        });
        editor.on('Change', (e: any) => {
          console.log('changed', e);
        });
      },
      pagebreak_separator: "<p><div class='r_tag_pagebreak' style='display:block; clear:both; page-break-after:always;'><div style='display: none;'>Prevents empty tag removal</div></div></p>",
      pagebreak_split_block: false,
      protect: [/\<p\>\<div class=\'r_tag_pagebreak\' style=\'display:block; clear:both; page-break-after:always;\'\>\<div style=\'display: none;\'\>Prevents empty tag removal\<\/div\>\<\/div\>\<\/p\>/g],
    });
  }

  enableNativeSpellcheck(editor: any) {
    const body = editor && typeof editor.getBody === 'function' ? editor.getBody() : null;
    if (!body) return;

    body.setAttribute('spellcheck', 'true');
    body.spellcheck = true;
  }

  setContent(text: string) {
    console.log('setting content', this.editor);
    if (this.editor) this.editor.setContent(text);
  }

  triggerContentOutput() {
    if (!this.editor) return;
    const content = this.editor.getContent();
    if (!content) return;
    this.onEditorKeyup.emit(content);
    this.wordCount.emit(this.editor.plugins.wordcount.getCount());
  }
}
